import { Component, OnInit, OnChanges, Output, EventEmitter, SimpleChanges, Input } from '@angular/core';
import * as _ from 'lodash';
import { DynamicFieldsService } from '../dynamic-fields.service';

@Component({
    selector: 'dynfield-select-simple',
    template: require('./dynamic-fields.select-simple.component.html')
})
export class DynamicFieldSelectSimpleComponent implements OnInit, OnChanges {
    @Input() field: any;
    @Input() version: any;
    @Input() fieldId: string;
    @Input() fieldData: any;
    @Input() fieldOptions: any;
    @Input() fieldError: any;
    @Input() allowUpdate: any;
    @Input() classes: string;

    @Output() fieldDataChange = new EventEmitter<any>();

    isRequired: boolean;
    selectedElement: any;
    error: any;

    constructor(private dynamicFieldsService: DynamicFieldsService) { }

    ngOnInit(): void {
        this.error = this.dynamicFieldsService.setError(this.fieldError, this.field);
        this.isRequired = this.dynamicFieldsService.isRequired(this);
        this.selectedElement = _.find(this.fieldOptions.fieldElements, { id: this.fieldData });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.fieldError) {
            this.error = this.dynamicFieldsService.setError(
                changes.fieldError?.currentValue, this.field
            );
        }
    }

    clearError(): void {
        this.error = null;
    }

    setValue(event: any): void {
        this.fieldData = event.target.value;
        this.fieldDataChange.emit(this.fieldData);
        
        this.clearError();
    }
}
